import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

/** Latest change first by default, like the old leave list's default `{ LastUpdateDate: -1 }` sort. */
export const DEFAULT_LEAVE_REQUESTS_ORDER: OrderBy[] = [
  { field: 'LastUpdatedDate', direction: 'DESC' },
];

export const buildGetLeaveRequestsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_LEAVE_REQUESTS_ORDER
) => `
  query {
    LeaveRequests: getLeaveRequests(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ItemId
        CreatedDate
        Title
        UserId
        DisplayName
        Email
        DepartmentName
        LeaveCategoryId
        LeaveCategory
        LeaveType
        StartDate
        EndDate
        IsFirstHalf
        Reason
        Note
        Status
        IsArchived
        FileIds
        IsDocumentSendByDr
        Timezone
      }
    }
  }
`;
